<template>
  <div class="loginWrapper">
    <div class="row">
      <div class="col-sm"></div>
      <div class="col-sm"><LogoView/></div>
      <div class="col-sm"></div>
    </div>
      <RouterView></RouterView>
      <p class="secondaryText defaultPadding">- Powered by <a href="https://kappuccino.uk" target="_blank">kAppuccino</a> -</p>
    <div class="row">
      <div class="col">
        <a href="https://kappuccino.uk/macchiato/privacy.html" target="_blank" class="activeLink">Privacy Policy</a>
      </div>
      <div class="col">
        <a href="https://kappuccino.uk/macchiato/terms.html" target="_blank" class="activeLink">Terms of Use</a>
      </div>
      <div class="col">
        <a href="https://apps.apple.com/gb/app/macchiato/id1529092126" target="_blank"><img src="../assets/appstore_dark.svg"/></a>
      </div>
    </div>
  </div>
</template>

<script>
import LogoView from '../Components/LogoView.vue'
export default {
  name: 'Login',
  components : {
    LogoView
  },
  created : function() {
    //If local session token doesnt exist
      //redirect to login
      //this.$router.push('/login');
      if (window.localStorage.getItem('macchiato-token') != null) {
          this.$router.push('/');
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.loginWrapper {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
